import * as colors from "@material-ui/core/colors";

export default {
  root: {
    backgroundColor: colors.grey[50],
    whiteSpace: "nowrap",
  },
};
